import { alias, equal, reads } from '@ember/object/computed';

import Model, { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import { CMS_LANGUAGE_IDS } from 'umg-ember-backend/utils/cms-languages';
import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  cmsLanguageId: validator('inclusion', { in: CMS_LANGUAGE_IDS }),
  headline: validator('presence', true),
  embedService: [validator('belongs-to'), validator('presence', true)],
});

export const settings = {
  saveHooks: {
    before: [
      function prepareMediaEmbedOptions(model) {
        // Keep new embed option changes from being lost to the attr default value.
        model.embedOptions = model.embedOptions || {};

        return model;
      },
    ],
  },
};

export default class MediaEmbedModel extends Model.extend(Validations) {
  @attr('color-hex', { defaultValue: '#ffffff' }) backgroundColor;
  @attr('string') embedId;
  @attr('media-embed-config', {
    defaultValue: function () {
      return {
        appleMusicCode: null,
        facebookCode: null,
        instagramCode: null,
        spotifyCode: null,
        soundcloudCode: null,
        tiktokCode: null,
        twitterCode: null,
        vimeoAutoplay: false,
        vimeoLoop: false,
        vimeoTitle: false,
        vimeoByline: false,
        vimeoPortrait: false,
        youtubeSuggestVideos: false,
        youtubeShowControls: true,
        youtubeShowInfo: true,
        youtubeDataProtection: false,
        youtubeStartAt: null,
      };
    },
  })
  embedOptions;
  @attr('string') headline;

  // CMS fields
  @attr('string', { defaultValue: '1' }) cmsLanguageId;
  @attr('number', { defaultValue: 2 }) cmsState;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) backgroundImage;
  @hasMany('channel', { async: true, inverse: null }) channels;
  @belongsTo('category', { async: true, inverse: null }) embedService;

  // Getter, setter and computed properties
  @reads('embedService.name') entitySubtype;
  @equal('embedService.shortName', 'apple-music') isAppleMusic;
  @equal('embedService.shortName', 'facebook') isFacebook;
  @equal('embedService.shortName', 'instagram') isInstagram;
  @equal('embedService.shortName', 'soundcloud') isSoundcloud;
  @equal('embedService.shortName', 'spotify') isSpotify;
  @equal('embedService.shortName', 'tiktok') isTiktok;
  @equal('embedService.shortName', 'twitter') isTwitter;
  @equal('embedService.shortName', 'vimeo') isVimeo;
  @equal('embedService.shortName', 'youtube') isYoutube;
  @alias('headline') displayHeadline;

  get displayLabel() {
    return `${this.headline} (${this.id})`;
  }
}
